<template>
<el-container class="app-layout">
  <!-- 页面左侧 -->
  <el-aside class="layout-aside">
    <!-- logo展示 -->
    <logo />
    <!-- 菜单栏 -->
    <sidebar />
  </el-aside>
  <!-- 页面中间部分 -->
  <el-container class="layout-container">
    <!-- 路由导航栏 -->
    <el-header class="layout-header">
      <navbar />
      <!-- <tags-view /> -->
    </el-header>
    <!-- 页面主要内容 -->
    <el-main class="layout-main">
      <slot></slot>
    </el-main>
  </el-container>
</el-container>
</template>

<script>
// 整体布局
import { Logo, Sidebar, Navbar } from "./components";
export default {
  components: {
    Logo,
    Sidebar,
    Navbar,
  },
  setup() {
  }
}
</script>

<style lang="scss" scoped>
.app-layout {
  height: 100%;
  width: 100%;

  .layout-aside {
    height: 100%;
    width: 260px;
    color: #1f225f;
    background-color: #ffffff;
    -webkit-box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
    box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
    -webkit-transition: width 0.28s;
    transition: width 0.28s;
  }

  .layout-aside-min-width {
    width: 64px;
  }

  .layout-header {
    padding: 0;
    // height: 85px;
  }

  .layout-main {
    padding: 15px 20px;
  }
}
</style>
